// ! 为排查处方特殊的问题而特地写的组件, 后续可能会被删除
// ! 删除请谨慎，已经经过一次处方改版需求了，需要和原先的prescriptionForm核对，包括SelectPopupExtra和ActionSheet/indexForPrescription
import Checkbox from '@/components/Form/Checkbox';
import MenuItem from '@/components/Form/MenuItem';
import QuestionResponsive from '@/components/IconResponsive/QuestionResponsive';
import WebOnly from '@/components/Responsive/WebOnly';
import { useStore } from '@/providers/app-store-provider';
import logger from '@/utils/client-logger';
import { IS_DE, LocaleType } from '@/utils/constants';
import { EPrescriptionType } from '@/utils/enums/goods';
import { hasPrism, hasTwoPd } from '@/utils/prescription';
import { Collapse } from '@mui/material';
import { cva } from 'class-variance-authority';
import { useLocale } from 'next-intl';
import { useTranslations } from '@/i18n/use-translations';
import { useEffect, useMemo, useState } from 'react';
import { Control, FormProvider, useController, useForm } from 'react-hook-form';
import ActionSheet from '../ActionSheet';
// import Button from '../Button';
import WapOnly from '../Responsive/WapOnly';
// import PDDialog from './components/PDDialog';
// import PrismDialog from './components/PrismDialog';
import Select from './components/Select';
import SelectPopup from './SelectPopupExtra';
import { IPrescriptionOptions } from './types';
import { getEmptyPrescription, getOptions, handlerPrescriptionData } from './utils';

interface PrescriptionFormProps {
  className?: string;
  /** 处方类型 */
  prescriptionType: EPrescriptionType;
  pd_min?: string;
  pd_max?: string;
  /** 处方选项 */
  prescriptionOptions: IPrescriptionOptions;

  name: string;
  /** 变化回调 */
  onChange?: (key: string, value: string | boolean | undefined, json?: string) => void;
  /** 提交回调 */
  onSubmit?: (data: any) => void;
  control: Control<any>;
  /** 点击PD问题回调 */
  onClickPdHelp?: () => void;
  onClickPrismHelp?: () => void;
  /** PD类型更改 */
  onPdCheckChange?: (checked: boolean) => void;
  /** 添加Prism（包括2种情况：移动端的添加，PC端的勾选切换） */
  onAddPrism?: (checked: boolean) => void;
  /** 删除Prism */
  onDeletePrism?: () => void;
  /** 打开select选择框（PC）/  选择弹层（WAP）. 注：value暂时没实现，后面有需要再实现 */
  onOpen?: (type: string, value?: string | boolean | undefined) => void;
}

export default function PrescriptionForm({
  className,
  prescriptionType,
  pd_min,
  pd_max,
  prescriptionOptions,
  onChange,
  name,
  control,
  onClickPdHelp,
  onClickPrismHelp,
  onPdCheckChange,
  onAddPrism,
  // onDeletePrism,
  onOpen,
}: PrescriptionFormProps) {
  const t = useTranslations('prescriptionForm');
  const waiMode = useStore((state) => state.waiMode);
  const { field } = useController({
    control,
    name,
    rules: {
      validate: () => {
        const isValid = validateForm();
        return isValid;
      },
    },
  });
  const lensProT = useTranslations('lens-process');
  // const [isPrismDialogOpen, setIsPrismDialogOpen] = useState(false);

  const addPlus = () => {
    try {
      Object.keys(prescriptionOptions).forEach((key) => {
        if (
          ['od_sph', 'os_sph', 'od_cyl', 'os_cyl', 'od_add', 'os_add'].includes(key) &&
          Number(prescriptionOptions[key]) > 0
        ) {
          prescriptionOptions[key] = `+${parseFloat(String(prescriptionOptions[key])).toFixed(2)}`;
        }
      });
    } catch (error) {
      logger.warn('PrescriptionForm====', error);
    }
  };
  addPlus();

  try {
    Object.keys(prescriptionOptions).forEach((key) => {
      if (
        ['od_sph', 'os_sph', 'od_cyl', 'os_cyl', 'od_add', 'os_add'].includes(key) &&
        Number(prescriptionOptions[key]) > 0
      ) {
        prescriptionOptions[key] = `+${parseFloat(String(prescriptionOptions[key])).toFixed(2)}`;
      }
    });
  } catch (error) {
    logger.warn('PrescriptionForm====', error);
  }

  const prescriptionFormMethods = useForm<IPrescriptionOptions>({
    mode: 'onChange',
    defaultValues: {
      od_sph: prescriptionOptions.od_sph,
      os_sph: prescriptionOptions.os_sph,
      od_cyl: prescriptionOptions.od_cyl,
      os_cyl: prescriptionOptions.os_cyl,
      od_axis: prescriptionOptions.od_axis,
      os_axis: prescriptionOptions.os_axis,
      od_add: prescriptionOptions.od_add,
      os_add: prescriptionOptions.os_add,
      is_two_pd: hasTwoPd(prescriptionOptions),
      pd: prescriptionOptions.pd,
      pd_l: prescriptionOptions.pd_l,
      pd_r: prescriptionOptions.pd_r,
      is_prism: hasPrism(prescriptionOptions),
      od_pv: prescriptionOptions.od_pv,
      od_bd: prescriptionOptions.od_bd,
      os_pv: prescriptionOptions.os_pv,
      os_bd: prescriptionOptions.os_bd,
      od_pv_r: prescriptionOptions.od_pv_r,
      od_bd_r: prescriptionOptions.od_bd_r,
      os_pv_r: prescriptionOptions.os_pv_r,
      os_bd_r: prescriptionOptions.os_bd_r,
    },
  });

  // ActionSheet状态
  const [activeSheet, setActiveSheet] = useState<{
    open: boolean;
    field: string;
    title: string;
    optionsList: any[];
    value: string;
  }>({
    open: false,
    field: '',
    title: '',
    optionsList: [],
    value: '',
  });

  // 校验状态标志
  const [sphTipShow, setSphTipShow] = useState(0);
  const [cylTipShow, setCylTipShow] = useState(0);
  const [axisTipShow, setAxisTipShow] = useState(0);
  const [addTipShow, setAddTipShow] = useState(0);
  const [pdTipShow, setPdTipShow] = useState(0);
  const [prismTipShow, setPrismTipShow] = useState(0);

  // 使用watch监听is_two_pd的变化
  const od_sph = prescriptionFormMethods.watch('od_sph');
  const os_sph = prescriptionFormMethods.watch('os_sph');
  const od_cyl = prescriptionFormMethods.watch('od_cyl');
  const os_cyl = prescriptionFormMethods.watch('os_cyl');
  const od_axis = prescriptionFormMethods.watch('od_axis');
  const os_axis = prescriptionFormMethods.watch('os_axis');
  const od_add = prescriptionFormMethods.watch('od_add');
  const os_add = prescriptionFormMethods.watch('os_add');
  const isTwoPd = prescriptionFormMethods.watch('is_two_pd');
  const isPrism = prescriptionFormMethods.watch('is_prism');
  const od_pv = prescriptionFormMethods.watch('od_pv');
  const os_pv = prescriptionFormMethods.watch('os_pv');
  const od_bd = prescriptionFormMethods.watch('od_bd');
  const os_bd = prescriptionFormMethods.watch('os_bd');
  const od_pv_r = prescriptionFormMethods.watch('od_pv_r');
  const os_pv_r = prescriptionFormMethods.watch('os_pv_r');
  const od_bd_r = prescriptionFormMethods.watch('od_bd_r');
  const os_bd_r = prescriptionFormMethods.watch('os_bd_r');
  const pd = prescriptionFormMethods.watch('pd');
  const pd_l = prescriptionFormMethods.watch('pd_l');
  const pd_r = prescriptionFormMethods.watch('pd_r');

  const odAxisIsError: boolean = useMemo(() => {
    return !['0.00', 'SPH/DS'].includes(od_cyl) && od_axis === 'None';
  }, [od_axis, od_cyl]);

  const osAxisIsError: boolean = useMemo(() => {
    return !['0.00', 'SPH/DS'].includes(os_cyl) && os_axis === 'None';
  }, [os_axis, os_cyl]);

  // 判断是否为渐进镜类型
  const isProgressive =
    prescriptionType === EPrescriptionType.PROGRESSIVE ||
    prescriptionType === EPrescriptionType.READING_GLASSES ||
    prescriptionType === EPrescriptionType.PRESCRIPTION_READING;

  // 创建上下文对象用于获取选项数据
  const context = useMemo(() => {
    const min_pd = parseInt(pd_min, 10) || 54;
    const max_pd = parseInt(pd_max, 10) || 78;
    // const doublePdMin = min_pd % 2 === 0 ? min_pd / 2 - 2 : min_pd / 2 - 2.5;
    // const doublePdMax = max_pd % 2 === 0 ? max_pd / 2 + 2 : max_pd / 2 + 2.5;

    return {
      presType: prescriptionType,
      prescription: {
        is_two_pd: prescriptionOptions.is_two_pd,
      },
      // doublePdMin,
      // doublePdMax,
      usePd: {
        min_pd,
        max_pd,
      },
    };
  }, [prescriptionType, pd_min, pd_max]);

  // 校验提示信息
  const sphTipWord = [
    '',
    t('errorMessages.sph.differentSigns'),
    t('errorMessages.sph.abnormalValues'),
  ];

  const cylTipWord = [
    '',
    t('errorMessages.cyl.differentSigns'),
    t('errorMessages.cyl.abnormalValues'),
  ];

  const axisTipWord = ['', t('errorMessages.axis.required')];

  const addTipWord = ['', t('errorMessages.add.notZero'), t('errorMessages.add.mustBeSame')];

  const pdTipWord = [
    '',
    t('errorMessages.pd.required'),
    t('errorMessages.pd.tooBig'),
    t('errorMessages.pd.tooSmall'),
    t('errorMessages.pd.differenceTooLarge'),
  ];

  const prismTipWord = [
    '',
    t('errorMessages.prism.atLeastOne'),
    t('errorMessages.prism.valueAndDirection'),
  ];

  useEffect(() => {
    setSphTipShow(0);
    setCylTipShow(0);
    setAxisTipShow(0);
    setAddTipShow(0);
    setPdTipShow(0);
    setPrismTipShow(0);
  }, [prescriptionType]);

  /**
   * 校验SPH参数
   * @param data - 处方数据
   */
  const validateSPH = (data: IPrescriptionOptions) => {
    let od = parseFloat(data.od_sph);
    let os = parseFloat(data.os_sph);
    od = data.od_sph === 'PL' ? 0 : od;
    os = data.os_sph === 'PL' ? 0 : os;

    if (od < 0 !== os < 0 && od !== 0 && os !== 0) {
      // OD、OS的SPH值一正一负
      setSphTipShow(1);
    } else if (Math.abs(od - os) >= 3) {
      // OD、OS的SPH值相差大于等于3
      setSphTipShow(2);
    } else {
      setSphTipShow(0);
    }
  };

  /**
   * 校验CYL参数
   * @param data - 处方数据
   */
  const validateCYL = (data: IPrescriptionOptions) => {
    let od = parseFloat(data.od_cyl);
    let os = parseFloat(data.os_cyl);
    od = data.od_cyl === 'SPH/DS' ? 0 : od;
    os = data.os_cyl === 'SPH/DS' ? 0 : os;

    if (od < 0 !== os < 0 && od !== 0 && os !== 0) {
      // OD、OS的CYL值一正一负
      setCylTipShow(1);
    } else if (Math.abs(od - os) >= 3) {
      // OD、OS的CYL值相差大于等于3
      setCylTipShow(2);
    } else {
      setCylTipShow(0);
      validateAxis(data);
    }
  };

  /**
   * 校验AXIS参数
   * @param data - 处方数据
   * @returns 校验是否通过
   */
  const validateAxis = (data: IPrescriptionOptions) => {
    let isValid = true;
    // const { od_cyl, os_cyl, od_axis, os_axis } = data;

    // CYL不为0.00，Axis为None时提示
    if (!['SPH/DS', '0.00'].includes(data.od_cyl) && data.od_axis === 'None') {
      setAxisTipShow(1);
      isValid = false;
    } else if (!['SPH/DS', '0.00'].includes(data.os_cyl) && data.os_axis === 'None') {
      setAxisTipShow(1);
      isValid = false;
    } else {
      setAxisTipShow(0);
      isValid = true;
    }

    return isValid;
  };

  /**
   * 校验ADD参数
   * @param data - 处方数据
   * @param type - 指定变更的是左眼还是右眼
   * @returns 校验是否通过
   */
  const validateAdd = (data: IPrescriptionOptions, type?: 'od' | 'os') => {
    // 渐进镜需要同步左右眼ADD值
    if (prescriptionType === EPrescriptionType.PROGRESSIVE && type) {
      if (type === 'od') {
        prescriptionFormMethods.setValue('os_add', data.od_add);
      } else if (type === 'os') {
        prescriptionFormMethods.setValue('od_add', data.os_add);
      }

      onChange?.(type, data.od_add, JSON.stringify(prescriptionFormMethods.getValues()));
      setAddTipShow(0);
      return true;
    }

    let isValid = true;
    if (prescriptionType === EPrescriptionType.PROGRESSIVE) {
      if (data.od_add === '0.00' && data.os_add === '0.00') {
        setAddTipShow(1);
        isValid = false;
      } else if (data.od_add !== data.os_add) {
        // setAddTipShow(2);
        // isValid = false;
        // TODO: 此逻辑是否需要？
        logger.log('本逻辑不会触发，渐进镜处方是，左右眼 add 强制同步了');
      } else {
        setAddTipShow(0);
        isValid = true;
      }
    }

    return isValid;
  };

  /**
   * 验证PD值
   * @param data - 处方数据，默认为当前处方
   * @returns 校验是否通过
   */
  const validatePd = (data: IPrescriptionOptions) => {
    let isValid = true;

    if (data.is_two_pd) {
      // 双PD模式校验
      const totalPd = data.pd_l && data.pd_r ? Number(data.pd_l) + Number(data.pd_r) : 0;
      const pdDiff = Math.abs(Number(data.pd_l) - Number(data.pd_r));

      // 检查双PD总和是否在有效范围内
      if (!totalPd) {
        setPdTipShow(1);
        isValid = false;
      } else if (totalPd < context.usePd.min_pd) {
        setPdTipShow(3);
        isValid = false;
      } else if (totalPd > context.usePd.max_pd) {
        setPdTipShow(2);
        isValid = false;
      } else if (pdDiff >= 5) {
        setPdTipShow(4);
        isValid = true; // 双PD差值过大，也可以提交，展示提示语但是校验通过
      } else {
        setPdTipShow(0);
        isValid = true;
      }
    } else {
      // 单PD模式校验
      const pdValue = Number(data.pd);

      if (!data.pd) {
        setPdTipShow(1);
        isValid = false;
      } else if (pdValue > context.usePd.max_pd) {
        setPdTipShow(2);
        isValid = false;
      } else if (pdValue < context.usePd.min_pd) {
        setPdTipShow(3);
        isValid = false;
      } else {
        setPdTipShow(0);
        isValid = true;
      }
    }

    return isValid;
  };

  /**
   * 校验棱镜参数
   * @param data - 处方数据
   * @returns 校验是否通过
   */
  const validatePrism = (data: IPrescriptionOptions) => {
    // 斜视值校验
    let flag = true;
    if (data.is_prism) {
      // 至少选一组pv 和 bd值 od_bd od_bd_r od_pv od_pv_r os_bd os_bd_r os_pv os_pv_r
      if (
        ['od_pv', 'os_pv', 'od_pv_r', 'os_pv_r'].filter((item) => {
          return data[item] === '0.00' && data[item.replace('pv', 'bd')] === '';
        }).length === 4
      ) {
        flag = false;
        setPrismTipShow(1);
      }
      //  每组pv和bd值必须同时选择或同时不选
      if (
        ['od_pv', 'os_pv', 'od_pv_r', 'os_pv_r'].filter((item) => {
          return data[item] === '0.00' && data[item.replace('pv', 'bd')] !== '';
        }).length
      ) {
        flag = false;
        setPrismTipShow(2);
      }

      //  每组pv和bd值必须同时选择或同时不选
      if (
        ['od_pv', 'os_pv', 'od_pv_r', 'os_pv_r'].filter((item) => {
          return data[item] !== '0.00' && data[item.replace('pv', 'bd')] === '';
        }).length
      ) {
        flag = false;
        setPrismTipShow(2);
      }
    }
    if (flag) {
      setPrismTipShow(0);
    }
    return flag;
  };

  const resetPDValue = () => {
    prescriptionFormMethods.setValue('pd', '');
    prescriptionFormMethods.setValue('pd_r', '');
    prescriptionFormMethods.setValue('pd_l', '');

    setPdTipShow(1);
  };

  const handleOnOpen = (type: string) => {
    onOpen?.(type);
  };

  const onPresInfoChange = (type: string, value: string) => {
    prescriptionFormMethods.setValue(type, value);
    onChange?.(type, value, JSON.stringify(prescriptionFormMethods.getValues()));
    const prescription = prescriptionFormMethods.getValues();
    switch (type) {
      case 'od_sph':
      case 'os_sph':
        validateSPH(prescription);
        break;
      case 'od_cyl':
        if (prescription[type] === 'SPH/DS' || prescription[type] === '0.00') {
          prescriptionFormMethods.setValue('od_axis', 'None');
        }
        validateCYL(prescription);
        validateAxis(prescription);
        break;
      case 'os_cyl':
        if (prescription[type] === 'SPH/DS' || prescription[type] === '0.00') {
          prescriptionFormMethods.setValue('os_axis', 'None');
        }
        validateCYL(prescription);
        validateAxis(prescription);
        break;
      case 'os_axis':
        validateAxis(prescription);
        break;
      case 'od_axis':
        validateAxis(prescription);
        break;
      case 'od_add':
        validateAdd(prescription, 'od');
        break;
      case 'os_add':
        validateAdd(prescription, 'os');
        break;
      case 'pd':
      case 'pd_l':
      case 'pd_r':
        if (prescription.is_two_pd) {
          prescriptionFormMethods.setValue('pd', '');
        } else {
          prescriptionFormMethods.setValue('pd_l', '');
          prescriptionFormMethods.setValue('pd_r', '');
        }
        validatePd(prescription);
        break;
      case 'od_pv':
      case 'od_bd':
      case 'od_pv_r':
      case 'od_bd_r':
      case 'os_pv':
      case 'os_bd':
      case 'os_pv_r':
      case 'os_bd_r':
        if (!prescription.is_prism) {
          clearPrism();
        }
        validatePrism(prescription);
        break;
      default:
        break;
    }
  };

  /**
   * 校验整个表单
   * @returns 表单是否有效
   */
  const validateForm = () => {
    let isValid = true;
    const prescription = prescriptionFormMethods.getValues();
    // 执行所有校验
    if (!validateAxis(prescription)) {
      isValid = false;
    }

    if (!validateAdd(prescription)) {
      isValid = false;
    }

    validateSPH(prescription);
    validateCYL(prescription);

    if (!validatePd(prescription)) {
      isValid = false;
    }

    if (!validatePrism(prescription)) {
      isValid = false;
    }

    return isValid;
  };

  useEffect(() => {
    addPlus();
    prescriptionFormMethods.setValue('od_sph', prescriptionOptions.od_sph);
    prescriptionFormMethods.setValue('od_cyl', prescriptionOptions.od_cyl);
    prescriptionFormMethods.setValue('od_axis', prescriptionOptions.od_axis);
    prescriptionFormMethods.setValue('od_add', prescriptionOptions.od_add);
    prescriptionFormMethods.setValue('os_sph', prescriptionOptions.os_sph);
    prescriptionFormMethods.setValue('os_cyl', prescriptionOptions.os_cyl);
    prescriptionFormMethods.setValue('os_axis', prescriptionOptions.os_axis);
    prescriptionFormMethods.setValue('os_add', prescriptionOptions.os_add);

    const hasTwoPdValue = hasTwoPd(prescriptionOptions);
    prescriptionFormMethods.setValue('is_two_pd', hasTwoPdValue);
    prescriptionFormMethods.setValue('is_prism', hasPrism(prescriptionOptions));
    prescriptionFormMethods.setValue('od_pv', prescriptionOptions.od_pv);
    prescriptionFormMethods.setValue('od_bd', prescriptionOptions.od_bd);
    prescriptionFormMethods.setValue('os_pv', prescriptionOptions.os_pv);
    prescriptionFormMethods.setValue('os_bd', prescriptionOptions.os_bd);
    prescriptionFormMethods.setValue('od_pv_r', prescriptionOptions.od_pv_r);
    prescriptionFormMethods.setValue('od_bd_r', prescriptionOptions.od_bd_r);
    prescriptionFormMethods.setValue('os_pv_r', prescriptionOptions.os_pv_r);
    prescriptionFormMethods.setValue('os_bd_r', prescriptionOptions.os_bd_r);
    prescriptionFormMethods.setValue('pd', prescriptionOptions.pd);
    prescriptionFormMethods.setValue('pd_l', prescriptionOptions.pd_l);
    // Ensure pd_r is properly set
    prescriptionFormMethods.setValue('pd_r', prescriptionOptions.pd_r);
    if (prescriptionOptions.id) {
      validateForm();
    }
  }, [prescriptionOptions]);
  useEffect(() => {
    setPrismTipShow(0);
  }, [isPrism]);
  useEffect(() => {
    if (od_cyl) {
      const _value = handlerPrescriptionData(prescriptionFormMethods.getValues());
      field.onChange(JSON.stringify(_value));
      // 同时可以调用props中的onChange（可选）
      // if (onChange) onChange(fullPhoneNumber);
    }
  }, [
    od_sph,
    os_sph,
    od_add,
    os_add,
    od_cyl,
    os_cyl,
    od_axis,
    os_axis,
    od_bd,
    os_bd,
    od_bd_r,
    os_bd_r,
    od_pv,
    os_pv,
    od_pv_r,
    os_pv_r,
    isTwoPd,
    isPrism,
    pd,
    pd_l,
    pd_r,
    field,
  ]);

  /**
   * 打开ActionSheet
   * @param field - 选择的字段
   * @param title - ActionSheet标题
   * @param disabled - 是否禁用
   */
  const openActionSheet = (_field: string, value = '') => {
    prescriptionFormMethods.setValue(_field, value);
    // if (
    //   ['od_pv', 'od_bd', 'od_pv_r', 'od_bd_r', 'os_pv', 'os_bd', 'os_pv_r', 'os_bd_r'].includes(
    //     _field,
    //   )
    // ) {
    //   onPresInfoChange('prism', value);
    // } else {
    // }
    onPresInfoChange(_field, value);
  };

  /**
   * 关闭ActionSheet
   */
  const closeActionSheet = () => {
    setActiveSheet((prev) => ({
      ...prev,
      open: false,
    }));
  };

  /**
   * 处理ActionSheet值变更 TODO 这里疑似没有在用
   * @param value - 选中的值
   */
  const handleActionSheetSave = (_field: string, value: string) => {
    logger.warn('handleActionSheetSave', _field, value);
    if (_field) {
      prescriptionFormMethods.setValue(_field, value);
      // 特殊处理渐进镜的ADD值，同时更新左右眼
      if (
        (activeSheet.field === 'od_add' || activeSheet.field === 'os_add') &&
        prescriptionType === EPrescriptionType.PROGRESSIVE
      ) {
        // 如果是渐进镜，同步更新左右眼ADD值
        onPresInfoChange('od_add', value);
        onPresInfoChange('os_add', value);
      } else {
        // 普通字段直接更新
        // handleChange(activeSheet.field)(value);
        onPresInfoChange(_field, value);
      }
    }
    closeActionSheet();
  };

  const clearPrism = () => {
    const resetPrescription = getEmptyPrescription();
    prescriptionFormMethods.setValue('od_pv', resetPrescription.od_pv);
    prescriptionFormMethods.setValue('od_bd', resetPrescription.od_bd);
    prescriptionFormMethods.setValue('od_pv_r', resetPrescription.od_pv_r);
    prescriptionFormMethods.setValue('od_bd_r', resetPrescription.od_bd_r);
    prescriptionFormMethods.setValue('os_pv', resetPrescription.os_pv);
    prescriptionFormMethods.setValue('os_bd', resetPrescription.os_bd);
    prescriptionFormMethods.setValue('os_pv_r', resetPrescription.os_pv_r);
    prescriptionFormMethods.setValue('os_bd_r', resetPrescription.os_bd_r);
    // setPrismTipShow(0);
  };
  const prescriptionFormStyle = cva('prescription-form', {
    variants: {
      locale: {
        en: 'w-[620px]',
        fr: 'w-[720px]',
        de: 'w-[620px]',
        es: 'w-[620px]',
        it: 'w-[620px]',
        pt: 'w-[620px]',
        fi: 'w-[620px]',
        nl: 'w-[620px]',
      },
    },
  });
  const formItemWidthStyle = cva('prescription-form', {
    variants: {
      locale: {
        en: isProgressive ? 'w-[121px]' : 'w-[161px]',
        fr: isProgressive ? 'w-[145px]' : 'w-[195px]',
        de: isProgressive ? 'w-[121px]' : 'w-[161px]',
        es: isProgressive ? 'w-[121px]' : 'w-[161px]',
        it: isProgressive ? 'w-[121px]' : 'w-[161px]',
        pt: isProgressive ? 'w-[121px]' : 'w-[161px]',
        fi: isProgressive ? 'w-[121px]' : 'w-[161px]',
        nl: isProgressive ? 'w-[121px]' : 'w-[161px]',
      },
    },
  });

  const twoPdFormItemLeftStyle = cva('', {
    variants: {
      locale: {
        en: isTwoPd
          ? `${isProgressive ? 'left-[379px]' : 'left-[459px]'}`
          : `${isProgressive ? 'left-[258px]' : 'left-[298px]'}`,
        fr: isTwoPd
          ? `${isProgressive ? 'left-[448px]' : 'left-[557px]'}`
          : `${isProgressive ? 'left-[317px]' : 'left-[357px]'}`,
        de: isTwoPd
          ? `${isProgressive ? 'left-[379px]' : 'left-[459px]'}`
          : `${isProgressive ? 'left-[258px]' : 'left-[298px]'}`,
        es: isTwoPd
          ? `${isProgressive ? 'left-[379px]' : 'left-[459px]'}`
          : `${isProgressive ? 'left-[258px]' : 'left-[298px]'}`,
        it: isTwoPd
          ? `${isProgressive ? 'left-[379px]' : 'left-[459px]'}`
          : `${isProgressive ? 'left-[258px]' : 'left-[298px]'}`,
        pt: isTwoPd
          ? `${isProgressive ? 'left-[379px]' : 'left-[459px]'}`
          : `${isProgressive ? 'left-[258px]' : 'left-[298px]'}`,
        fi: isTwoPd
          ? `${isProgressive ? 'left-[379px]' : 'left-[459px]'}`
          : `${isProgressive ? 'left-[258px]' : 'left-[298px]'}`,
        nl: isTwoPd
          ? `${isProgressive ? 'left-[379px]' : 'left-[459px]'}`
          : `${isProgressive ? 'left-[258px]' : 'left-[298px]'}`,
      },
    },
  });

  const prismFormItemWidthStyle = cva('', {
    variants: {
      locale: {
        en: 'w-[121px]',
        fr: 'w-[145px]',
        de: 'w-[121px]',
        es: 'w-[121px]',
        it: 'w-[121px]',
        pt: 'w-[121px]',
        fi: 'w-[121px]',
        nl: 'w-[121px]',
      },
    },
  });
  const twoPd2ndFormItemLeftStyle = cva('', {
    variants: {
      locale: {
        en: isTwoPd ? `${isProgressive ? 'left-[258px]' : 'left-[298px]'}` : ``,
        fr: isTwoPd ? `${isProgressive ? 'left-[282px]' : 'left-[332px]'}` : ``,
        de: isTwoPd ? `${isProgressive ? 'left-[258px]' : 'left-[298px]'}` : ``,
        es: isTwoPd ? `${isProgressive ? 'left-[258px]' : 'left-[298px]'}` : ``,
        it: isTwoPd ? `${isProgressive ? 'left-[258px]' : 'left-[298px]'}` : ``,
        pt: isTwoPd ? `${isProgressive ? 'left-[258px]' : 'left-[298px]'}` : ``,
        fi: isTwoPd ? `${isProgressive ? 'left-[258px]' : 'left-[298px]'}` : ``,
        nl: isTwoPd ? `${isProgressive ? 'left-[258px]' : 'left-[298px]'}` : ``,
      },
    },
  });
  const locale = useLocale() as LocaleType;
  /** 德语站：数值展示时小数点改为逗号（仅影响展示，表单值仍为点号） */
  const formatDecimalForDisplay = (str: string) => {
    if (str == null || typeof str !== 'string') return '';
    return IS_DE ? str.replace('.', ',') : str;
  };

  const SelectPopupField = ({
    _field,
    title,
    disabled = false,
    value = '',
    centerValue = '',
    isError = false,
    placeholder = '',
  }: {
    _field: string;
    title: string;
    disabled?: boolean;
    value?: string;
    centerValue?: string;
    isError?: boolean;
    placeholder?: string;
  }) => {
    return (
      <SelectPopup
        title={title}
        titleClassName={'notranslate'}
        value={value}
        formatValue={IS_DE ? formatDecimalForDisplay : undefined}
        options={getOptions(_field, context).map((option) => ({
          label: ['In', 'Out', 'Up', 'Down'].includes(option)
            ? t(`fieldLabels.${option}` as any)
            : formatDecimalForDisplay(option),
          value: option,
        }))}
        onSave={(_value) => {
          openActionSheet(_field, _value);
        }}
        onOpen={() => {
          handleOnOpen(_field);
        }}
        disabled={disabled}
        centerValue={centerValue}
        isError={isError}
        placeholder={placeholder}
      />
    );
  };

  const grayColor = waiMode ? '' : 'text-secondary-text';

  return (
    <FormProvider {...prescriptionFormMethods}>
      <WebOnly>
        <div className={`${prescriptionFormStyle({ locale })} ${className}`}>
          {/* SPH CYL AXIS 表单 */}
          <div className="base-form  rounded-6 border border-[#d4d4d4] overflow-hidden notranslate">
            {/* 表头，蓝色背景 */}
            <div className="row flex justify-start text-center bg-[#edf2fc]">
              <div
                className={`title w-[137px] h-48 border-r flex items-center justify-center font-bb text-14 border-[#d4d4d4]`}
              >
                <span>&nbsp;</span>
              </div>
              <div
                className={`title ${formItemWidthStyle({ locale })} h-48 border-r flex items-center justify-center font-bb text-14 text-[#282828] border-[#d4d4d4]`}
              >
                <span>{t('fieldLabels.sph')}</span>
              </div>
              <div
                className={`title ${formItemWidthStyle({ locale })} h-48 border-r flex items-center justify-center font-bb text-14 text-[#282828] border-[#d4d4d4]`}
              >
                <span>{t('fieldLabels.cyl')}</span>
              </div>
              <div
                className={`title ${formItemWidthStyle({ locale })} h-48 ${isProgressive ? 'border-r' : ''} flex items-center justify-center font-bb text-14 text-[#282828] border-[#d4d4d4]`}
              >
                <span>{t('fieldLabels.axis')}</span>
              </div>
              {isProgressive && (
                <div
                  className={`title ${prismFormItemWidthStyle({ locale })} h-48 flex items-center justify-center font-bb text-14 text-[#282828]`}
                >
                  <span>{t('fieldLabels.add')}</span>
                </div>
              )}
            </div>
            {/* 表单内容 右眼 */}
            <div className="row flex justify-start text-center ">
              <div
                className={`title w-[137px] h-48 border-r border-t border-[#d4d4d4] pl-12 flex items-center justify-start font-bb text-14 text-[#282828] bg-[#edf2fc]`}
              >
                <span className="text-left">
                  {t('eyeLabels.od')} <br />
                  <span className={`font-br text-12 ${grayColor}`}> {t('eyeLabels.odHint')}</span>
                </span>
              </div>
              <div
                className={`title ${formItemWidthStyle({ locale })} h-48 border-r border-t flex items-center justify-center font-bb text-14 text-[#282828] border-[#d4d4d4] overflow-hidden`}
              >
                <Select
                  noBorder
                  formItemClassName="w-full"
                  control={prescriptionFormMethods.control}
                  name="od_sph"
                  onChange={(e) => {
                    onPresInfoChange('od_sph', e.target.value as string);
                  }}
                  onOpen={() => {
                    handleOnOpen('od_sph');
                  }}
                >
                  {getOptions('od_sph', context).map((option) => (
                    <MenuItem key={option} value={option}>
                      {formatDecimalForDisplay(option)}
                    </MenuItem>
                  ))}
                </Select>
                {/* centerValue="0.00"  */}
              </div>
              <div
                className={`title ${formItemWidthStyle({ locale })} h-48 border-r border-t flex items-center justify-center font-bb text-14 border-[#d4d4d4] overflow-hidden`}
              >
                <Select
                  noBorder
                  formItemClassName="w-full"
                  control={prescriptionFormMethods.control}
                  name="od_cyl"
                  onChange={(e) => {
                    onPresInfoChange('od_cyl', e.target.value as string);
                  }}
                  onOpen={() => {
                    handleOnOpen('od_cyl');
                  }}
                >
                  {getOptions('od_cyl', context).map((option) => (
                    <MenuItem key={option} value={option}>
                      {formatDecimalForDisplay(option)}
                    </MenuItem>
                  ))}
                </Select>
                {/* centerValue="0.00" */}
              </div>
              <div
                className={`title ${formItemWidthStyle({ locale })} h-48 ${isProgressive ? 'border-r' : ''} border-t flex items-center justify-center font-bb text-14 border-[#d4d4d4] overflow-hidden`}
              >
                <Select
                  noBorder
                  formItemClassName="w-full"
                  className={`${odAxisIsError ? '!text-error' : ''}`}
                  control={prescriptionFormMethods.control}
                  name="od_axis"
                  disabled={od_cyl === '0.00' || od_cyl === 'SPH/DS'}
                  onChange={(e) => {
                    onPresInfoChange('od_axis', e.target.value as string);
                  }}
                  onOpen={() => {
                    handleOnOpen('od_axis');
                  }}
                >
                  {getOptions('od_axis', context).map((option) => (
                    <MenuItem key={option} value={option}>
                      {formatDecimalForDisplay(option)}
                    </MenuItem>
                  ))}
                </Select>
                {/* centerValue="20" */}
              </div>
              {isProgressive && (
                <div
                  className={`title ${prismFormItemWidthStyle({ locale })} h-48 flex items-center border-t border-[#d4d4d4] justify-center font-bb text-14 overflow-hidden`}
                >
                  <Select
                    noBorder
                    formItemClassName="w-full"
                    control={prescriptionFormMethods.control}
                    className={`${addTipShow > 0 ? '!text-error' : ''}`}
                    name="od_add"
                    onChange={(e) => {
                      onPresInfoChange('od_add', e.target.value as string);
                    }}
                    onOpen={() => {
                      handleOnOpen('od_add');
                    }}
                  >
                    {getOptions('od_add', context).map((option) => (
                      <MenuItem key={option} value={option}>
                        {formatDecimalForDisplay(option)}
                      </MenuItem>
                    ))}
                  </Select>
                  {/* centerValue="+0.50", placeholder="0.00" */}
                </div>
              )}
            </div>

            {/* 表单内容 左眼 */}
            <div className="row flex justify-start text-center ">
              <div
                className={`title w-[137px] h-48 border-r border-t pl-12 flex items-center justify-start font-bb text-14 text-[#282828] border-[#d4d4d4] bg-[#edf2fc]`}
              >
                <span className="text-left">
                  {t('eyeLabels.os')} <br />
                  <span className={`font-br text-12 ${grayColor}`}> {t('eyeLabels.osHint')}</span>
                </span>
              </div>
              <div
                className={`title ${formItemWidthStyle({ locale })} h-48 border-r border-t flex items-center justify-center font-bb text-14 text-[#282828] border-[#d4d4d4] overflow-hidden`}
              >
                <Select
                  noBorder
                  formItemClassName="w-full"
                  control={prescriptionFormMethods.control}
                  name="os_sph"
                  onChange={(e) => {
                    onPresInfoChange('os_sph', e.target.value as string);
                  }}
                  onOpen={() => {
                    handleOnOpen('os_sph');
                  }}
                >
                  {getOptions('os_sph', context).map((option) => (
                    <MenuItem key={option} value={option}>
                      {formatDecimalForDisplay(option)}
                    </MenuItem>
                  ))}
                </Select>
                {/* centerValue="0.00" */}
              </div>
              <div
                className={`title ${formItemWidthStyle({ locale })} h-48 border-r border-t flex items-center justify-center font-bb text-14 border-[#d4d4d4] overflow-hidden`}
              >
                <Select
                  noBorder
                  formItemClassName="w-full"
                  control={prescriptionFormMethods.control}
                  name="os_cyl"
                  onChange={(e) => {
                    onPresInfoChange('os_cyl', e.target.value as string);
                  }}
                  onOpen={() => {
                    handleOnOpen('os_cyl');
                  }}
                >
                  {getOptions('os_cyl', context).map((option) => (
                    <MenuItem key={option} value={option}>
                      {formatDecimalForDisplay(option)}
                    </MenuItem>
                  ))}
                </Select>
                {/* centerValue="0.00" */}
              </div>
              <div
                className={`title ${formItemWidthStyle({ locale })} h-48 ${isProgressive ? 'border-r' : ''} border-t flex items-center justify-center font-bb text-14 border-[#d4d4d4] overflow-hidden`}
              >
                <Select
                  noBorder
                  formItemClassName="w-full"
                  control={prescriptionFormMethods.control}
                  name="os_axis"
                  disabled={os_cyl === '0.00' || os_cyl === 'SPH/DS'}
                  className={`${osAxisIsError ? '!text-error' : ''}`}
                  onChange={(e) => {
                    onPresInfoChange('os_axis', e.target.value as string);
                  }}
                  onOpen={() => {
                    handleOnOpen('os_axis');
                  }}
                >
                  {getOptions('os_axis', context).map((option) => (
                    <MenuItem key={option} value={option}>
                      {formatDecimalForDisplay(option)}
                    </MenuItem>
                  ))}
                </Select>
                {/* centerValue="20" */}
              </div>
              {isProgressive && (
                <div
                  className={`title ${prismFormItemWidthStyle({ locale })} h-48 flex items-center border-t border-[#d4d4d4] justify-center font-bb text-14 overflow-hidden`}
                >
                  <Select
                    noBorder
                    formItemClassName="w-full"
                    control={prescriptionFormMethods.control}
                    className={`${addTipShow > 0 ? '!text-error' : ''}`}
                    name="os_add"
                    onChange={(e) => {
                      onPresInfoChange('os_add', e.target.value as string);
                    }}
                    onOpen={() => {
                      handleOnOpen('os_add');
                    }}
                  >
                    {getOptions('os_add', context).map((option) => (
                      <MenuItem key={option} value={option}>
                        {formatDecimalForDisplay(option)}
                      </MenuItem>
                    ))}
                  </Select>
                  {/* centerValue="0.00" placeholder="0.00" */}
                </div>
              )}
            </div>
          </div>
          <div className="text-14 text-error mt-10 font-br">
            {axisTipShow > 0 && (
              <div className="tip-box form-error-text">
                <div />
                <div className="pres-tip">{axisTipWord[axisTipShow]}</div>
              </div>
            )}
            {!axisTipShow && addTipShow > 0 && (
              <div className="tip-box form-error-text">
                <div className="pres-tip">{addTipWord[addTipShow]}</div>
              </div>
            )}
            {!axisTipShow && !addTipShow && sphTipShow > 0 && (
              <div className="tip-box form-error-text">
                <div className="pres-tip">{sphTipWord[sphTipShow]}</div>
              </div>
            )}
            {!axisTipShow && !addTipShow && !sphTipShow && cylTipShow > 0 && (
              <div className="tip-box form-error-text">
                <div className="pres-tip">{cylTipWord[cylTipShow]}</div>
              </div>
            )}
          </div>
        </div>
        <div className={`${prescriptionFormStyle({ locale })} ${className}`}>
          {/* 校验提示信息显示区域 */}
          <div className="w-full mt-14 flex items-center relative">
            <div className="title w-[137px] h-48 border-r font-bb bg-[#edf2fc] rounded-l-6 border  text-14 text-[#282828] border-[#d4d4d4] flex items-center notranslate">
              <span className="pl-12 text-left">
                {t('fieldLabels.pd')} <br />
                <span className={`font-br text-12 ${grayColor}`}> {t('fieldLabels.pdHint')}</span>
              </span>
            </div>
            {/* TODO: 暂时用这种Hack的方式修复每次切换单PD和双PD的时候，默认空值展示会偶尔闪烁的问题，之前通过Select组件的重建来实现会有这个问题 */}
            {/* 具体为什么会这样，后续再排查问题 */}
            <div
              className={`${isTwoPd ? 'double-pd' : 'single-pd'} ${formItemWidthStyle({ locale })} h-48 ${!isTwoPd ? 'rounded-r-6' : ''} bg-whites border-t border-r border-b border-[#d4d4d4] flex items-center justify-center text-14 text-[#282828] overflow-hidden notranslate`}
            >
              <Select
                noBorder
                formItemClassName="w-full"
                className={`${pdTipShow > 0 ? '!text-error' : ''}`}
                control={prescriptionFormMethods.control}
                name={!isTwoPd ? 'pd' : 'pd_r'}
                defaultDisplayValue={!isTwoPd ? 'PD' : `${t('fieldLabels.pdRight')}`}
                centerValue={!isTwoPd ? '63.00' : '32.00'}
                value={!isTwoPd ? pd : pd_r}
                onChange={(e) => {
                  onPresInfoChange(!isTwoPd ? 'pd' : 'pd_r', e.target.value as string);
                }}
                onOpen={() => {
                  handleOnOpen(!isTwoPd ? 'pd' : 'pd_r');
                }}
              >
                {getOptions(!isTwoPd ? 'pd' : 'pd_r', context).map((option) => (
                  <MenuItem key={option} value={option}>
                    {formatDecimalForDisplay(option)}
                  </MenuItem>
                ))}
              </Select>
            </div>
            <div
              className={`double-pd ${formItemWidthStyle({ locale })} ${twoPd2ndFormItemLeftStyle({ locale })} h-48 rounded-r-6 bg-whites border-t border-r border-b border-[#d4d4d4] flex items-center justify-center text-14 text-[#282828] overflow-hidden notranslate`}
              style={{
                opacity: isTwoPd ? 1 : 0,
                position: 'absolute',
                pointerEvents: isTwoPd ? 'auto' : 'none',
              }}
            >
              <Select
                noBorder
                formItemClassName="w-full"
                className={`${pdTipShow > 0 ? '!text-error' : ''}`}
                control={prescriptionFormMethods.control}
                name="pd_l"
                defaultDisplayValue={`${t('fieldLabels.pdLeft')}`}
                centerValue="32.00"
                onChange={(e) => {
                  onPresInfoChange('pd_l', e.target.value as string);
                }}
                onOpen={() => {
                  handleOnOpen('pd_l');
                }}
              >
                {getOptions('pd_l', context).map((option) => (
                  <MenuItem key={option} value={option}>
                    {formatDecimalForDisplay(option)}
                  </MenuItem>
                ))}
              </Select>
            </div>

            <div
              className={`w-[160px] flex items-center pl-8 absolute ${twoPdFormItemLeftStyle({ locale })}`}
            >
              <Checkbox
                control={prescriptionFormMethods.control}
                name="is_two_pd"
                label={
                  <span className="text-14 font-br text-nowrap">{t('buttons.twoPdNumbers')}</span>
                }
                isThinner
                onChange={(e) => {
                  resetPDValue();
                  onPdCheckChange?.(e.target.checked);
                }}
              />
              <QuestionResponsive
                className="cursor-pointer absolute right-8 f16 hover:text-primary-purple"
                onClick={() => {
                  // setIsPDDialogOpen(true);
                  onClickPdHelp?.();
                }}
              />
              {/* <PDDialog open={isPDDialogOpen} onClose={() => setIsPDDialogOpen(false)} /> */}
            </div>
          </div>
          <div className="text-error mt-10 ">
            {pdTipShow > 0 && (
              <span className="text-14 font-br form-error-text">{pdTipWord[pdTipShow]}</span>
            )}
          </div>
        </div>
        <div className={`${prescriptionFormStyle({ locale })} ${className} mt-[30px]`}>
          <div className="w-full">
            <div className="flex items-center">
              <Checkbox
                control={prescriptionFormMethods.control}
                name="is_prism"
                sx={{
                  marginRight: '6px',
                }}
                label={<span className="text-14 font-br text-nowrap">{t('buttons.addPrism')}</span>}
                isThinner
                onChange={(e) => {
                  clearPrism();
                  onAddPrism?.(e.target.checked);
                }}
              />

              <QuestionResponsive
                className="cursor-pointer f16 hover:text-primary-purple"
                onClick={() => {
                  // setIsPrismDialogOpen(true);
                  onClickPrismHelp?.();
                }}
              />
              {/* <PrismDialog open={isPrismDialogOpen} onClose={() => setIsPrismDialogOpen(false)} /> */}
            </div>
            <Collapse in={isPrism} timeout={500} className="notranslate">
              <div className="base-form bg-[#edf2fc] rounded-6 border border-[#d4d4d4] overflow-hidden mt-2 mb-[32px]">
                <div className="row flex justify-between text-center notranslate">
                  <div className="title w-[137px] h-48 border-r flex items-center justify-center font-bb text-14 border-[#d4d4d4] ">
                    <span>&nbsp;</span>
                  </div>
                  <div
                    className={`title ${prismFormItemWidthStyle({ locale })} h-48 border-r flex items-center justify-center font-bb text-14 text-[#282828] border-[#d4d4d4]`}
                  >
                    <span
                      dangerouslySetInnerHTML={{
                        __html: t('fieldLabels.prismHorizontal'),
                      }}
                    />
                  </div>
                  <div
                    className={`title ${prismFormItemWidthStyle({ locale })} h-48 border-r flex items-center justify-center font-bb text-14 text-[#282828] border-[#d4d4d4]`}
                  >
                    <span
                      dangerouslySetInnerHTML={{
                        __html: t('fieldLabels.baseDirection'),
                      }}
                    />
                  </div>
                  <div
                    className={`title ${prismFormItemWidthStyle({ locale })} h-48 border-r flex items-center justify-center font-bb text-14 text-[#282828] border-[#d4d4d4]`}
                  >
                    <span
                      dangerouslySetInnerHTML={{
                        __html: t('fieldLabels.prismVertical'),
                      }}
                    />
                  </div>
                  <div
                    className={`title ${prismFormItemWidthStyle({ locale })} h-48 flex items-center justify-center font-bb text-14 text-[#282828]`}
                  >
                    <span
                      dangerouslySetInnerHTML={{
                        __html: t('fieldLabels.baseDirection'),
                      }}
                    />
                  </div>
                </div>

                {/* OD 右眼 */}
                <div className="row flex justify-between text-center">
                  <div className="title w-[137px] h-48 border-r border-t flex items-center justify-start font-bb text-14 text-[#282828] border-[#d4d4d4]">
                    <span className="pl-12 text-left">
                      {t('fieldLabels.od')} <br />
                      <span className={`font-br text-12 ${grayColor}`}>
                        {t('fieldLabels.right')}
                      </span>
                    </span>
                  </div>
                  <div
                    className={`title ${prismFormItemWidthStyle({ locale })} h-48 bg-white border-r border-t flex items-center justify-center font-bb text-14 text-[#282828] border-[#d4d4d4] overflow-hidden`}
                  >
                    <Select
                      noBorder
                      formItemClassName="w-full"
                      control={prescriptionFormMethods.control}
                      name="od_pv"
                      onChange={(e) => {
                        onPresInfoChange('od_pv', e.target.value as string);
                      }}
                      onOpen={() => {
                        handleOnOpen('od_pv');
                      }}
                    >
                      {getOptions('od_pv', context).map((option) => (
                        <MenuItem key={option} value={option}>
                          {formatDecimalForDisplay(option)}
                        </MenuItem>
                      ))}
                    </Select>
                    {/* centerValue="0.00" */}
                  </div>
                  <div
                    className={`title ${prismFormItemWidthStyle({ locale })} h-48 bg-white border-r border-t flex items-center justify-center font-bb text-14 border-[#d4d4d4] overflow-hidden`}
                  >
                    <Select
                      noBorder
                      value={od_bd ? t(`fieldLabels.${od_bd}` as any) : ''}
                      formItemClassName="w-full"
                      control={prescriptionFormMethods.control}
                      name="od_bd"
                      className={`${od_pv !== '0.00' && od_bd === '' ? '!text-error' : ''}`}
                      defaultDisplayValue={t('fieldLabels.select')}
                      disabled={od_pv === '0.00'}
                      onChange={(e) => {
                        onPresInfoChange('od_bd', e.target.value as string);
                      }}
                      onOpen={() => {
                        handleOnOpen('od_bd');
                      }}
                    >
                      {getOptions('od_bd', context).map((option) => (
                        <MenuItem key={option} value={option}>
                          {['In', 'Out', 'Up', 'Down'].includes(option)
                            ? t(`fieldLabels.${option}` as any)
                            : formatDecimalForDisplay(option)}
                        </MenuItem>
                      ))}
                    </Select>
                    {/* centerValue="0.00"`  */}
                  </div>
                  <div
                    className={`title ${prismFormItemWidthStyle({ locale })} h-48 bg-white border-r border-t flex items-center justify-center font-bb text-14 border-[#d4d4d4] overflow-hidden`}
                  >
                    <Select
                      noBorder
                      formItemClassName="w-full"
                      control={prescriptionFormMethods.control}
                      name="od_pv_r"
                      onChange={(e) => {
                        onPresInfoChange('od_pv_r', e.target.value as string);
                      }}
                      onOpen={() => {
                        handleOnOpen('od_pv_r');
                      }}
                    >
                      {getOptions('od_pv_r', context).map((option) => (
                        <MenuItem key={option} value={option}>
                          {formatDecimalForDisplay(option)}
                        </MenuItem>
                      ))}
                    </Select>
                    {/* centerValue="0.00" */}
                  </div>
                  <div
                    className={`title ${prismFormItemWidthStyle({ locale })} h-48 bg-white border-t flex items-center justify-center font-bb text-14 border-[#d4d4d4] overflow-hidden`}
                  >
                    <Select
                      noBorder
                      formItemClassName="w-full"
                      control={prescriptionFormMethods.control}
                      name="od_bd_r"
                      defaultDisplayValue={t('fieldLabels.select')}
                      className={`${od_pv_r !== '0.00' && od_bd_r === '' ? '!text-error' : ''}`}
                      disabled={od_pv_r === '0.00'}
                      value={od_bd_r ? t(`fieldLabels.${od_bd_r}` as any) : ''}
                      onChange={(e) => {
                        onPresInfoChange('od_bd_r', e.target.value as string);
                      }}
                      onOpen={() => {
                        handleOnOpen('od_bd_r');
                      }}
                    >
                      {getOptions('od_bd_r', context).map((option) => (
                        <MenuItem key={option} value={option}>
                          {['In', 'Out', 'Up', 'Down'].includes(option)
                            ? t(`fieldLabels.${option}` as any)
                            : formatDecimalForDisplay(option)}
                        </MenuItem>
                      ))}
                    </Select>
                    {/* centerValue="0.00" */}
                  </div>
                </div>

                {/* OS 左眼 */}
                <div className="row flex justify-between text-center">
                  <div className="title w-[137px] h-48 border-r border-t flex items-center justify-start font-bb text-14 text-[#282828] border-[#d4d4d4]">
                    <span className="pl-12 text-left">
                      {t('fieldLabels.os')} <br />
                      <span className={`font-br text-12 ${grayColor}`}>
                        {t('fieldLabels.left')}
                      </span>
                    </span>
                  </div>
                  <div
                    className={`title ${prismFormItemWidthStyle({ locale })} h-48 bg-white border-r border-t flex items-center justify-center font-bb text-14 border-[#d4d4d4] overflow-hidden`}
                  >
                    <Select
                      noBorder
                      formItemClassName="w-full"
                      control={prescriptionFormMethods.control}
                      name="os_pv"
                      onChange={(e) => {
                        onPresInfoChange('os_pv', e.target.value as string);
                      }}
                      onOpen={() => {
                        handleOnOpen('os_pv');
                      }}
                    >
                      {getOptions('os_pv', context).map((option) => (
                        <MenuItem key={option} value={option}>
                          {formatDecimalForDisplay(option)}
                        </MenuItem>
                      ))}
                    </Select>
                    {/* centerValue="0.00" */}
                  </div>
                  <div
                    className={`title ${prismFormItemWidthStyle({ locale })} h-48 bg-white border-r border-t flex items-center justify-center font-bb text-14 border-[#d4d4d4] overflow-hidden`}
                  >
                    <Select
                      noBorder
                      formItemClassName="w-full"
                      control={prescriptionFormMethods.control}
                      name="os_bd"
                      defaultDisplayValue={t('fieldLabels.select')}
                      disabled={os_pv === '0.00'}
                      className={`${os_pv !== '0.00' && os_bd === '' ? '!text-error' : ''}`}
                      value={os_bd ? t(`fieldLabels.${os_bd}` as any) : ''}
                      onChange={(e) => {
                        onPresInfoChange('os_bd', e.target.value as string);
                      }}
                      onOpen={() => {
                        handleOnOpen('os_bd');
                      }}
                    >
                      {getOptions('os_bd', context).map((option) => (
                        <MenuItem key={option} value={option}>
                          {['In', 'Out', 'Up', 'Down'].includes(option)
                            ? t(`fieldLabels.${option}` as any)
                            : formatDecimalForDisplay(option)}
                        </MenuItem>
                      ))}
                    </Select>
                    {/* centerValue="0.00" */}
                  </div>
                  <div
                    className={`title ${prismFormItemWidthStyle({ locale })} h-48 bg-white border-r border-t flex items-center justify-center font-bb text-14 border-[#d4d4d4] overflow-hidden`}
                  >
                    <Select
                      noBorder
                      formItemClassName="w-full"
                      control={prescriptionFormMethods.control}
                      name="os_pv_r"
                      onChange={(e) => {
                        onPresInfoChange('os_pv_r', e.target.value as string);
                      }}
                      onOpen={() => {
                        handleOnOpen('os_pv_r');
                      }}
                    >
                      {getOptions('os_pv_r', context).map((option) => (
                        <MenuItem key={option} value={option}>
                          {formatDecimalForDisplay(option)}
                        </MenuItem>
                      ))}
                    </Select>
                    {/* centerValue="0.00" */}
                  </div>
                  <div
                    className={`title ${prismFormItemWidthStyle({ locale })} h-48 bg-white border-t flex items-center justify-center font-bb text-14 border-[#d4d4d4] overflow-hidden`}
                  >
                    <Select
                      noBorder
                      formItemClassName="w-full"
                      control={prescriptionFormMethods.control}
                      name="os_bd_r"
                      className={`${os_pv_r !== '0.00' && os_bd_r === '' ? '!text-error' : ''}`}
                      disabled={os_pv_r === '0.00'}
                      defaultDisplayValue={t('fieldLabels.select')}
                      value={os_bd_r ? t(`fieldLabels.${os_bd_r}` as any) : ''}
                      onChange={(e) => {
                        onPresInfoChange('os_bd_r', e.target.value as string);
                      }}
                      onOpen={() => {
                        handleOnOpen('os_bd_r');
                      }}
                    >
                      {getOptions('os_bd_r', context).map((option) => (
                        <MenuItem key={option} value={option}>
                          {['In', 'Out', 'Up', 'Down'].includes(option)
                            ? t(`fieldLabels.${option}` as any)
                            : formatDecimalForDisplay(option)}
                        </MenuItem>
                      ))}
                    </Select>
                    {/* centerValue="0.00" */}
                  </div>
                </div>
              </div>
              {prismTipShow > 0 && (
                <div className="text-error mt-[-22px] ">
                  <span className="text-14 font-br form-error-text">
                    {prismTipWord[prismTipShow]}
                  </span>
                </div>
              )}
            </Collapse>
          </div>
        </div>
      </WebOnly>
      <WapOnly>
        <div className={`w-full prescription-form-pc ${className}`}>
          {/* SPH CYL AXIS 表单 */}
          <div className="base-form bg-[#edf2fc] rounded-6 border border-[#d4d4d4] overflow-hidden notranslate">
            <div className="row flex justify-between text-center notranslate">
              <div
                className={`title w-1/4 h-48 border-r flex items-center justify-center font-bb text-14 border-[#d4d4d4]`}
              >
                <span>&nbsp;</span>
              </div>
              <div
                className={`title w-1/4 h-48 border-r flex items-center justify-center font-bb text-14 border-[#d4d4d4]`}
              >
                <span>{t('fieldLabels.sph')}</span>
              </div>
              <div
                className={`title w-1/4 h-48 border-r flex items-center justify-center font-bb text-14 border-[#d4d4d4]`}
              >
                <span>{t('fieldLabels.cyl')}</span>
              </div>
              <div
                className={`title w-1/4 h-48  flex items-center justify-center font-bb text-14 border-[#d4d4d4]`}
              >
                <span>{t('fieldLabels.axis')}</span>
              </div>
            </div>

            {/* 右眼 OD */}
            <div className="row flex justify-between text-center">
              <div
                className={`title w-1/4 h-48 border-r border-t flex items-center justify-start font-bb text-14 border-[#d4d4d4]`}
              >
                <span className="pl-12 text-left">
                  <span className="notranslate">{t('fieldLabels.od')}</span> <br />
                  <span className={`font-br text-12 ${grayColor}`}>{t('fieldLabels.right')}</span>
                </span>
              </div>

              <div
                className={`title w-1/4 h-48 bg-white border-r border-t flex items-center justify-center text-14 border-[#d4d4d4]`}
              >
                <SelectPopupField _field="od_sph" title={t('fieldLabels.sphOd')} value={od_sph} />
              </div>
              <div
                className={`title w-1/4 h-48 bg-white border-r border-t flex items-center justify-center text-14 border-[#d4d4d4]`}
              >
                <SelectPopupField _field="od_cyl" title={t('fieldLabels.cylOd')} value={od_cyl} />
              </div>
              <div
                className={`title w-1/4 h-48 bg-white  border-t flex items-center justify-center  text-14 border-[#d4d4d4]`}
              >
                <SelectPopupField
                  _field="od_axis"
                  title={t('fieldLabels.axisOd')}
                  disabled={od_cyl === '0.00' || od_cyl === 'SPH/DS'}
                  value={od_axis}
                  isError={odAxisIsError}
                />
              </div>
            </div>

            {/* 左眼 */}
            <div className="row flex justify-between text-center">
              <div
                className={`title w-1/4 h-48 border-r border-t flex items-center justify-start font-bb text-14 border-[#d4d4d4]`}
              >
                <span className="pl-12 text-left">
                  <span className="notranslate">{t('fieldLabels.os')}</span> <br />
                  <span className={`font-br text-12 ${grayColor}`}>{t('fieldLabels.left')}</span>
                </span>
              </div>
              <div
                className={`title w-1/4 h-48 bg-white border-r border-t flex items-center justify-center text-14 border-[#d4d4d4]`}
              >
                <SelectPopupField _field="os_sph" title={t('fieldLabels.sphOs')} value={os_sph} />
              </div>
              <div
                className={`title w-1/4 h-48 bg-white border-r border-t flex items-center justify-center  text-14 border-[#d4d4d4]`}
              >
                <SelectPopupField _field="os_cyl" title={t('fieldLabels.cylOs')} value={os_cyl} />
              </div>
              <div
                className={`title w-1/4 h-48 bg-white  border-t flex items-center justify-center  text-14 border-[#d4d4d4]`}
              >
                <SelectPopupField
                  _field="os_axis"
                  title={t('fieldLabels.axisOs')}
                  value={os_axis}
                  disabled={os_cyl === '0.00' || os_cyl === 'SPH/DS'}
                  isError={osAxisIsError}
                />
              </div>
            </div>
          </div>

          {/* 校验提示信息显示区域 */}
          <div className="mt-3">
            <div className="form-col-box text-14">
              {axisTipShow > 0 && (
                <div className="tip-box p-2 my-2 bg-light-yellow rounded form-error-text">
                  <div className="pres-tip text-error">{axisTipWord[axisTipShow]}</div>
                </div>
              )}

              {sphTipShow > 0 && !axisTipShow && !addTipShow && (
                <div className="tip-box p-2 my-2 bg-light-yellow rounded form-error-text">
                  <div className="pres-tip text-error">{sphTipWord[sphTipShow]}</div>
                </div>
              )}
              {cylTipShow > 0 && !axisTipShow && !addTipShow && !sphTipShow && (
                <div className="tip-box p-2 my-2 bg-light-yellow rounded form-error-text">
                  <div className="pres-tip text-error">{cylTipWord[cylTipShow]}</div>
                </div>
              )}
            </div>
          </div>

          {/* 渐进镜 */}

          {isProgressive && (
            <div className="w-full mt-16 flex items-center">
              <div className="title w-1/4 h-44 ">&nbsp;</div>
              <div className="title w-1/4 h-44 flex items-center justify-center gap-4">
                <span className="font-bb text-14 notranslate">{t('fieldLabels.od')} </span>
                <span className={`font-br text-12 ${grayColor}`}>{t('fieldLabels.right')}</span>
              </div>
              <div className="title w-1/4 h-44 flex items-center justify-center gap-4">
                <span className="font-bb text-14 notranslate">{t('fieldLabels.os')} </span>
                <span className={`font-br text-12 ${grayColor}`}>{t('fieldLabels.left')}</span>
              </div>
            </div>
          )}

          {isProgressive && (
            <div className="w-full flex items-center">
              <div className="title w-1/4 h-48 border-r font-bb bg-[#edf2fc] rounded-l-6 border  text-14 border-[#d4d4d4] flex items-center">
                <span className="pl-12 text-left notranslate">{t('fieldLabels.add')}</span>
              </div>
              <div className="title w-1/4 h-48 bg-white border-t border-[#d4d4d4] border-r border-b flex items-center justify-center text-14 overflow-hidden">
                <SelectPopupField _field="od_add" title={t('fieldLabels.addOd')} value={od_add} />
              </div>
              <div className="title w-1/4 h-48 bg-white border-t border-r border-b rounded-r-6 border-[#d4d4d4] flex items-center justify-center  text-14 overflow-hidden">
                <SelectPopupField _field="os_add" title={t('fieldLabels.addOs')} value={os_add} />
              </div>
            </div>
          )}

          {addTipShow > 0 && !axisTipShow && (
            <div className="text-14 tip-box p-2 my-2 bg-light-yellow rounded form-error-text">
              <div className="pres-tip text-error">{addTipWord[addTipShow]}</div>
            </div>
          )}

          <div className="w-full h-1 border-t border-[#d0d4db]  mt-20" />

          <div className={`w-full  flex items-center justify-between my-16 `}>
            <span className="font-bb text-14 notranslate">
              {t('mobileTitles.pupillaryDistance')}
            </span>
            {!isTwoPd && (
              <span
                className="font-br text-12 underline cursor-pointer"
                onClick={() => {
                  // setIsPDDialogOpen(true);
                  onClickPdHelp?.();
                }}
              >
                {t('mobileTitles.findPdHelp')}
              </span>
            )}
            {/* <PDDialog open={isPDDialogOpen} onClose={() => setIsPDDialogOpen(false)} /> */}
          </div>

          {/* pd */}
          <div className="w-full mt-10 flex items-center notranslate">
            <div className="title w-1/4 h-48 border-r font-bb bg-[#edf2fc] rounded-l-6 border  text-14 border-[#d4d4d4] flex items-center">
              <span className="pl-12 text-left notranslate">{t('fieldLabels.pd')}</span>
            </div>
            {!isTwoPd ? (
              <div className="single-pd w-1/4 h-48 rounded-r-6 bg-whites border-t border-r border-b border-[#d4d4d4] flex items-center justify-center text-14 overflow-hidden">
                <SelectPopupField
                  _field="pd"
                  title={t('fieldLabels.pd')}
                  placeholder={t('fieldLabels.pd')}
                  value={pd}
                  centerValue="63.00"
                  isError={pdTipShow > 0}
                />
              </div>
            ) : (
              <>
                <div className="double-pd w-1/4 h-48  bg-whites border-t border-r border-b border-[#d4d4d4] flex items-center justify-center text-14 overflow-hidden">
                  <SelectPopupField
                    _field="pd_r"
                    title={t('fieldLabels.pdRight')}
                    placeholder={t('fieldLabels.pureRight')}
                    value={pd_r}
                    centerValue="32.00"
                    isError={pdTipShow > 0}
                  />
                </div>
                <div className="double-pd w-1/4 h-48 rounded-r-6 bg-whites border-t border-r border-b border-[#d4d4d4] flex items-center justify-center text-14 overflow-hidden">
                  <SelectPopupField
                    _field="pd_l"
                    title={t('fieldLabels.pdLeft')}
                    placeholder={t('fieldLabels.pureLeft')}
                    value={pd_l}
                    isError={pdTipShow > 0}
                    centerValue="32.00"
                  />
                </div>
              </>
            )}
          </div>

          {/* 校验提示信息显示区域 */}

          {pdTipShow > 0 && (
            <div className="mt-5">
              <div className="text-14 tip-box mt-2 bg-light-yellow rounded form-error-text">
                <div className="pres-tip text-error">{pdTipWord[pdTipShow]}</div>
              </div>
            </div>
          )}

          <div className="mt-3 flex items-center">
            <div className=" flex items-center">
              <Checkbox
                control={prescriptionFormMethods.control}
                name="is_two_pd"
                label={t('fieldLabels.twoPdNumbers')}
                isThinner
                onChange={(e) => {
                  resetPDValue();
                  onPdCheckChange?.(e.target.checked);
                }}
                sx={{
                  '& .MuiTypography-root': { fontSize: '14px' },
                  '& .MuiFormControlLabel-root': { marginRight: '4px' },
                }}
              />
            </div>
          </div>

          <div className="w-full h-1 border-t border-[#d0d4db] my-4" />
          <div className="mt-3 flex items-center">
            <div className=" flex items-center">
              <Checkbox
                control={prescriptionFormMethods.control}
                name="is_prism"
                label={lensProT('havePrism')}
                isThinner
                sx={{
                  marginRight: '4px',

                  '& .MuiTypography-root': { fontSize: '14px' },
                }}
                onChange={(e) => {
                  clearPrism();
                  onAddPrism?.(e.target.checked);
                }}
              />
              <QuestionResponsive
                className="cursor-pointer f16 text-[#808080]"
                onClick={() => {
                  // setIsPrismDialogOpen(true);
                  onClickPrismHelp?.();
                }}
              />
            </div>
          </div>
          {/* Prism 斜视 */}
          {/* <div className="mt-[14px] mb-[10px] flex items-center justify-between">
            <div className="text-16 font-bb flex items-center gap-4">
              {t('buttons.prism')}{' '}
              <QuestionResponsive
                className="cursor-pointer f16 text-[#808080]"
                onClick={() => {
                  setIsPrismDialogOpen(true);
                  onClickPrismHelp?.();
                }}
              />
              <PrismDialog open={isPrismDialogOpen} onClose={() => setIsPrismDialogOpen(false)} />
            </div>
            {isPrism ? (
              <Button
                variant="text"
                color="primary"
                onClick={() => {
                  prescriptionFormMethods.setValue('is_prism', false);
                  clearPrism();
                  onDeletePrism?.();
                  setPrismTipShow(0);
                }}
                sx={{
                  color: '#808080',
                  fontSize: '12px',
                  backgroundColor: 'transparent',
                  textDecoration: 'underline',
                  '&:hover': {
                    textDecoration: 'underline',
                    backgroundColor: 'transparent',
                  },
                  '&:focus': {
                    textDecoration: 'underline',
                    backgroundColor: 'transparent',
                  },
                  textDecorationColor: '#808080',
                }}
              >
                {t('buttons.delete')}
              </Button>
            ) : (
              <Button
                variant="outlined"
                color="primary"
                sx={{
                  '& .MuiButtonBase-root': {
                    height: '24px',
                    fontSize: '12px',
                  },
                  height: '24px',
                }}
                onClick={() => {
                  prescriptionFormMethods.setValue('is_prism', true);
                  clearPrism();
                  onAddPrism?.();
                }}
              >
                {t('buttons.add')}
              </Button>
            )}
          </div> */}

          <Collapse in={isPrism} timeout={500} className="notranslate">
            <div className="base-form bg-[#edf2fc] rounded-6 border border-[#d4d4d4] mt-2 overflow-hidden">
              <div className="row flex justify-between text-center">
                <div className="title w-1/4 h-48 border-r flex items-center justify-center font-bb text-14 border-[#d4d4d4]">
                  <span>&nbsp;</span>
                </div>
                <div className="title w-3/8 h-48 border-r flex items-center justify-center font-bb text-14 border-[#d4d4d4]">
                  <span
                    dangerouslySetInnerHTML={{
                      __html: t('fieldLabels.prismHorizontal'),
                    }}
                  />
                </div>
                <div className="title w-3/8 h-48 flex items-center justify-center font-bb text-14 border-[#d4d4d4]">
                  <span
                    dangerouslySetInnerHTML={{
                      __html: t('fieldLabels.baseDirection'),
                    }}
                  />
                </div>
              </div>

              {/* OD 右眼 */}
              <div className="row flex justify-between text-center">
                <div className="title w-1/4 h-48 border-r border-t flex items-center justify-start font-bb text-14 border-[#d4d4d4]">
                  <span className="pl-12 text-left">
                    {t('fieldLabels.od')} <br />
                    <span className={`font-br text-12 ${grayColor}`}>{t('fieldLabels.right')}</span>
                  </span>
                </div>
                <div className="title w-3/8 h-48 bg-white border-r border-t flex items-center justify-center  text-14 border-[#d4d4d4]">
                  <SelectPopupField
                    _field="od_pv"
                    title={t('fieldLabels.prismHorizontalOd')}
                    value={od_pv}
                  />
                </div>
                <div className="title w-3/8 h-48 bg-white border-t flex items-center justify-center  text-14 border-[#d4d4d4]">
                  <SelectPopupField
                    _field="od_bd"
                    title={t('fieldLabels.baseDirectionOd')}
                    value={od_bd ? t(`fieldLabels.${od_bd}` as any) : ''}
                    placeholder={t('fieldLabels.select')}
                    isError={od_pv !== '0.00' && od_bd === ''}
                    disabled={od_pv === '0.00'}
                  />
                </div>
              </div>

              {/* OS 左眼 */}
              <div className="row flex justify-between text-center">
                <div className="title w-1/4 h-48 border-r border-t flex items-center justify-start font-bb text-14 border-[#d4d4d4]">
                  <span className="pl-12 text-left">
                    {t('fieldLabels.os')} <br />
                    <span className={`font-br text-12 ${grayColor}`}>{t('fieldLabels.left')}</span>
                  </span>
                </div>
                <div className="title w-3/8 h-48 bg-white border-r border-t flex items-center justify-center  text-14 border-[#d4d4d4]">
                  <SelectPopupField
                    _field="os_pv"
                    title={t('fieldLabels.prismHorizontalOs')}
                    value={os_pv}
                    placeholder={t('fieldLabels.select')}
                  />
                </div>
                <div className="title w-3/8 h-48 bg-white border-t flex items-center justify-center  text-14 border-[#d4d4d4]">
                  <SelectPopupField
                    _field="os_bd"
                    title={t('fieldLabels.baseDirectionOs')}
                    value={os_bd ? t(`fieldLabels.${os_bd}` as any) : ''}
                    placeholder={t('fieldLabels.select')}
                    isError={os_pv !== '0.00' && os_bd === ''}
                    disabled={os_pv === '0.00'}
                  />
                </div>
              </div>
            </div>

            <div className="base-form  bg-[#edf2fc] rounded-6 border border-[#d4d4d4] mt-20 overflow-hidden">
              <div className="row flex justify-between text-center">
                <div className="title w-1/4 h-48 border-r flex items-center justify-center font-bb text-14 border-[#d4d4d4]">
                  <span>&nbsp;</span>
                </div>

                <div className="title w-3/8 h-48 border-r flex items-center justify-center font-bb text-14 border-[#d4d4d4]">
                  <span
                    dangerouslySetInnerHTML={{
                      __html: t('fieldLabels.prismVertical'),
                    }}
                  />
                </div>
                <div className="title w-3/8 h-48 flex items-center justify-center font-bb text-14">
                  <span
                    dangerouslySetInnerHTML={{
                      __html: t('fieldLabels.baseDirection'),
                    }}
                  />
                </div>
              </div>

              {/* OD 右眼 */}
              <div className="row flex justify-between text-center">
                <div className="title w-1/4 h-48 border-r border-t flex items-center justify-start font-bb text-14 border-[#d4d4d4]">
                  <span className="pl-12 text-left">
                    {t('fieldLabels.od')} <br />
                    <span className={`font-br text-12 ${grayColor}`}>{t('fieldLabels.right')}</span>
                  </span>
                </div>

                <div className="title w-3/8 h-48 bg-white border-r border-t flex items-center justify-center  text-14 border-[#d4d4d4]">
                  <SelectPopupField
                    _field="od_pv_r"
                    title={t('fieldLabels.prismVerticalOd')}
                    value={od_pv_r}
                  />
                </div>
                <div className="title w-3/8 h-48 bg-white border-t flex items-center justify-center  text-14 border-[#d4d4d4]">
                  <SelectPopupField
                    _field="od_bd_r"
                    title={t('fieldLabels.baseDirectionOd')}
                    value={od_bd_r ? t(`fieldLabels.${od_bd_r}` as any) : ''}
                    placeholder={t('fieldLabels.select')}
                    disabled={od_pv_r === '0.00'}
                    isError={od_pv_r !== '0.00' && od_bd_r === ''}
                  />
                </div>
              </div>

              {/* OS 左眼 */}
              <div className="row flex justify-between text-center">
                <div className="title w-1/4 h-48 border-r border-t flex items-center justify-start font-bb text-14 border-[#d4d4d4]">
                  <span className="pl-12 text-left">
                    {t('fieldLabels.os')} <br />
                    <span className={`font-br text-12 ${grayColor}`}>{t('fieldLabels.left')}</span>
                  </span>
                </div>
                <div className="title w-3/8 h-48 bg-white border-r border-t flex items-center justify-center  text-14 border-[#d4d4d4]">
                  <SelectPopupField
                    _field="os_pv_r"
                    title={t('fieldLabels.prismVerticalOs')}
                    value={os_pv_r}
                    placeholder={t('fieldLabels.select')}
                  />
                </div>
                <div className="title w-3/8 h-48 bg-white border-t flex items-center justify-center  text-14 border-[#d4d4d4]">
                  <SelectPopupField
                    _field="os_bd_r"
                    title={t('fieldLabels.baseDirectionOs')}
                    value={os_bd_r ? t(`fieldLabels.${os_bd_r}` as any) : ''}
                    placeholder={t('fieldLabels.select')}
                    disabled={os_pv_r === '0.00'}
                    isError={os_pv_r !== '0.00' && os_bd_r === ''}
                  />
                </div>
              </div>
            </div>
          </Collapse>
          {/* 校验提示信息显示区域 */}
          <div className="mt-3">
            {prismTipShow > 0 && (
              <div className="text-14 tip-box p-2 my-2 bg-light-yellow rounded form-error-text">
                <div className="pres-tip text-error">{prismTipWord[prismTipShow]}</div>
              </div>
            )}
          </div>

          <div className={`w-full h-1 border-t border-[#d0d4db] my-4 ${isPrism ? 'mt-20' : ''}`} />
        </div>

        {/* 单个ActionSheet组件服务所有字段 */}
        <ActionSheet
          open={activeSheet.open}
          title={activeSheet.title}
          options={activeSheet.optionsList}
          onSave={(value) => handleActionSheetSave(activeSheet.field, value)}
          onClose={closeActionSheet}
          value={activeSheet.value}
        />
      </WapOnly>
    </FormProvider>
  );
}
